<template>
<div class="title-bar">
  <b-navbar toggleable="md" class="title-nav">
    <b-navbar-brand href="#" class="d-flex align-items-center">
      <img src="@/assets/img/logo-with-name.png" class="logo-icon"/>
      <div class="logo-name">ALMOND GLOBAL</div>
    </b-navbar-brand>

    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav>
        <b-nav-item to="/home" class="ml-50" :active="activeMenu === '/home'" >{{ $t('i18n.Website.Home') }}</b-nav-item>
        <b-nav-item to="/services" class="ml-50" :active="activeMenu === '/services'" >{{ $t('i18n.Website.Services') }}</b-nav-item>
        <b-nav-item to="/about" class="ml-50" :active="activeMenu === '/about'" >{{ $t('i18n.Website.About') }}</b-nav-item>
        <b-nav-item to="/blog" class="ml-50" :active="activeMenu === '/blog'"  >{{ $t('i18n.Website.Blog') }}</b-nav-item>
        <b-nav-item to="/faq" class="ml-50" :active="activeMenu === '/faq'"  >{{ $t('i18n.Website.FAQ') }}</b-nav-item>
      </b-navbar-nav>

      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
          <b-nav-item right @click="showLoginModal()" class="mr-1">Login</b-nav-item>
          <b-nav-item-dropdown text="Lang" right>
          <b-dropdown-item href="#">EN</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>

  <modal :title="$t('i18n.Process.Login')" ref="LoginModal" mid="LoginModal">
    <b-form-input
      v-model="$v.loginForm.email.$model"
      :state="$v.loginForm.email.$dirty ? !$v.loginForm.email.$error : null"
      placeholder="Email:"
      trim>
    </b-form-input>

    <b-form-input class="mt-3"
      v-model="$v.loginForm.name.$model"
      :state="$v.loginForm.name.$dirty ? !$v.loginForm.name.$error : null"
      placeholder="Name:"
      trim>
    </b-form-input>

    <div class="d-flex justify-content-between mt-3">
      <b-form-checkbox
        id="checkbox-1"
        v-model="status"
        name="checkbox-1"
        value="accepted"
        unchecked-value="not_accepted"
      >
      {{ $t('i18n.Process.Remember') }}
      </b-form-checkbox>

      <b-link to="forget" @click="hideLoginModal()">{{ $t('i18n.Process.Forget') }}</b-link>
    </div>

    <b-button variant="primary" class="mt-3 rounded-0" block @click="login()">{{ $t('i18n.Process.Login') }}</b-button>
  </modal>

</div>
</template>

<script>
import Modal from '../../components/Modal'
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
import md5 from 'js-md5'
import urltool from '../../util/urltool'
import request from '../../util/request'

export default {
  name: 'titleBar',
  mixins: [validationMixin],
  components: {
    Modal
  },
  data: function () {
    return {
      loginForm: {
        name: '',
        email: ''
      },
      status: ''
    }
  },
  validations: {
    loginForm: {
      name: {
        required
      },
      email: {
        required,
        email
      }
    }
  },
  computed: {
    activeMenu () {
      return this.$route.path
    }
  },
  methods: {
    showLoginModal: function () {
      this.$refs['LoginModal'].openModal()
    },

    hideLoginModal: function () {
      this.$refs['LoginModal'].hideModal()
    },

    login: function () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }

      let requestForm = {
        'username': this.loginForm.email,
        'password': md5(this.loginForm.name)
      }

      request.post('/login' + urltool.combParamByJson(requestForm)).then(
        response => {
          let responseCode = response.code
          let roleId = response.data && response.data.roleId

          if (responseCode !== 0) {
            alert('Login Failed')
            return
          }

          const adminHost = 'https://admin.almondglobal.com'
          const inspectorHost = 'https://inspector.almondglobal.com'
          const sellerHost = 'https://inspections.almondglobal.com'

          if (roleId === 1 || roleId === 4) {
            window.location.href = adminHost + '/index.html'
          } else if (roleId === 2) {
            window.location.href = sellerHost + '/dashboard.html'
          } else if (roleId === 3) {
            window.location.href = inspectorHost + '/dashboard.html'
          } else {
            alert('Login Failed')
          }
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped>

.title-bar {
  max-width: 100%;
  box-shadow: 0 1px 4px 0 rgba(0,0,0,0.10);
  // position: sticky;
  background-color: #FFFFFF;
}

.title-nav {
  max-width: 100%;
  margin: 0 auto;
}

.logo-name {
  font-size: 11px;
  height: 14px;
  color: #222222;
  display: block;
  margin-left: 4px;
}

.logo-icon {
  width: 40px;
  height: 40px;
}

@media (min-width: 1000px) {
  .title-nav {
    max-width: 1000px;
  }

  .ml-50 {
    margin-left: 50px !important;
  }
}

@media (min-width: 500px) {
  .logo-icon {
    width: 80px;
    height: 80px;
  }

  .logo-name {
    display: none;
  }
}

.ml-50 {
  margin-left: 25px;
}

.navbar-brand {
  padding: 0px;
}

.active {
  font-weight: bold;
  border-bottom: .1rem solid #4E98FF;
}
</style>



// WEBPACK FOOTER //
// src/Layout/components/title-bar.vue